// extracted by mini-css-extract-plugin
export default {"InfoIcon":"InfoIcon__VOmb53jC1F6a","corner":"corner___GId0f2tdj9T"};